import React from 'react';
import { Stack, Divider } from '@mui/material';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { FormValues } from '../../types';
import CollapseSection from '../CollapseSection';
import AddCustomContentButton from './AddCustomContentButton';
import AddCustomSectionButton from './AddCustomSectionButton';
import { useTranslation } from 'services/localization';
import CustomContentController from './CustomContentController';

const CustomSection = () => {
	const { control, watch } = useFormContext<FormValues>();
	const sections = watch('onlineLayout.about.customContent.sections');

	const { remove } = useFieldArray({
		control,
		name: 'onlineLayout.about.customContent.sections',
	});
	const { t } = useTranslation();

	return (
		<>
			{!!sections?.length &&
				sections.map((section, i) => {
					return (
						<>
							<CollapseSection
								id={section.id}
								heading={t('channels.online.customizer.section', 'Section')}
								onDelete={() => remove(i)}
							>
								<>
									{section?.content?.map((content, j) => {
										return (
											<Stack key={j} spacing={1}>
												<CustomContentController sectionIndex={i} contentIndex={j} />
											</Stack>
										);
									})}
								</>
								<AddCustomContentButton sectionIndex={i} />
							</CollapseSection>
						</>
					);
				})}
			<Divider />
			<AddCustomSectionButton />
		</>
	);
};

export default CustomSection;
